<template>
  <div class="default-layout">
    <el-container>
      <!-- 页头 -->
      <el-header class="page-header" :class="header === '64' ? 'header-64' : 'header-85'">
        <page-header ref="header" :layout="'default'" :password-modify-visible="passwordModifyVisible">
          <template slot="title">
            <img v-if="!logoText" :src="baseUrl + 'global/header-logo.svg'" />
            <div v-if="logoText" class="logo-text">{{ title }}</div>
          </template>
          <template slot="right-panel" v-if="rightNavbar">
            <right-navbar />
          </template>
        </page-header>
      </el-header>
      <base-container ref="baseContainer" :layout="'default'" :class="header === '64' ? 'container-64' : ''"
                      :initMenu="initMenu" />
    </el-container>
    <!--  修改密码组件  -->
    <password-modify ref="passwordModifyDialog" :specifyUserUuid="users.uid" />
    <!--文件预览弹框-->
    <file-preview ref="filePreview" />
  </div>
</template>
<script>
export default {
  name: "DefaultLayout",
  data() {
    return {
      users: this.$store.state.users,
      api: this.$store.state.api,
      baseUrl: this.$store.state.baseUrl,
      title: this.$store.state.title,
      header: this.$route.meta.header,
      logoText:this.$route.meta.logoText,
      rightNavbar: this.$route.meta.rightNavbar,
      passwordModifyVisible: this.$route.meta.passwordModifyVisible,
      initMenu: this.$route.meta.initMenu,
    };
  },
  created() {
    //监听postmessage
    window.addEventListener("message", this.messageHandler, false);
    window.addEventListener("storage", this.storageHandler, false);
  },
  mounted() {
    this.$zwxCookie.addCookie("nothingDoingTime", Date.now().toString());
    this.initMenu = window.localStorage.getItem("initMenu");
  },
  methods: {
    storageHandler() {
      if (!this.$zwxCookie.getCookie("zwxToken")) {
        this.$router.push({ name: "Login" });
      }
    },
    modifyPassword() {
      this.$refs.passwordModifyDialog.modifyPassword();
    },
    messageHandler(event) {
      const { data } = event;
      this[data.handlerType] && this[data.handlerType](data.params);
    },
    menuJump(val) {
      this.$refs.baseContainer.menuJump(val.name);
    },
    previewFile(data) {
      let previewFileList = [];
      if (!this.$zwxBase.verifyIsBlank(data.fileList)) {
        data.fileList.forEach(file => {
          let item = {
            fileName: file.fileName,
            filePath: file.filePath
          };
          previewFileList.push(item);
        });
      }
      this.$nextTick(function() {
        this.$refs.filePreview.initPreviewFile(previewFileList, data.index);
      });
    }
  },
  beforeDestroy() {
    // if (this.timer !== null) clearInterval(this.timer)
    window.removeEventListener("message", this.messageHandler, false);
    window.removeEventListener("storage", this.storageHandler, false);
  }
};
</script>

